import { render, staticRenderFns } from "./CompleteProfileModal.vue?vue&type=template&id=66640f3e&scoped=true&"
import script from "./CompleteProfileModal.vue?vue&type=script&lang=js&"
export * from "./CompleteProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./CompleteProfileModal.vue?vue&type=style&index=0&id=66640f3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66640f3e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckboxChecked: require('/opt/build/repo/components/icons/CheckboxChecked.vue').default,CheckboxUnchecked: require('/opt/build/repo/components/icons/CheckboxUnchecked.vue').default})
